module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/remortgage-barchart-sm-50a738d8da061139e134dbdeb0eb3e0f.svg";